import { render } from "./TemplatesTable.vue?vue&type=template&id=74f6fe16&scoped=true"
import script from "./TemplatesTable.vue?vue&type=script&lang=js"
export * from "./TemplatesTable.vue?vue&type=script&lang=js"

import "./TemplatesTable.vue?vue&type=style&index=0&id=74f6fe16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f6fe16"]])

export default __exports__